module.exports = __webpack_public_path__ + "static/media/hand.b91f49e4.svg";